import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import _ from 'lodash';

export class NCodeCharge extends TrackableEntity {
    id: number = 0;
    code: string = '';
    codeName: string = '';
    description: string = '';

    //데이터 저장용
    oi: string = '0';
    oo: string = '0';
    ai: string = '0';
    ao: string = '0';
    wh: string = '0';
    ot: string = '0'; // Payroll - 4, Brokerage Trucking - 5

    //체크박스 보여주기용
    oiForView: boolean = false;
    ooForView: boolean = false;
    aiForView: boolean = false;
    aoForView: boolean = false;
    whForView: boolean = false;
    otForView: boolean = false;
    btForView: boolean = false;

    sales1: string = '';
    cost1: string = '';
    chgType1: boolean = false;
    sales2: string = '';
    cost2: string = '';
    chgType2: boolean = false;
    sales3: string = '';
    cost3: string = '';
    chgType3: boolean = false;
    sales4: string = '';
    cost4: string = '';
    chgType4: boolean = false;
    sales5: string = '';
    cost5: string = '';
    chgType5: boolean = false;
    sales6: string = ''; //Payroll
    cost6: string = ''; //Payroll
    chgType6: boolean = false; //Payroll
    inActive: boolean = false;
    localDesc: string = '';
    jobNumber: number = 0;
    remark: string = '';
    useSuntek: boolean = false;
    isUseInInvoice: boolean = false;
    isUseInBill: boolean = false;
    isUseInWithhold: boolean = false; //Payroll
    isUseInCorporate: boolean = false; //Payroll
    inactiveDate: string | null = null;

    sales1Name: string = '';
    sales3Name: string = '';
    sales5Name: string = '';
    sales6Name: string = '';
    cost1Name: string = '';
    cost3Name: string = '';
    cost5Name: string = '';
    cost6Name: string = '';

    billingCodeSub: string = '';
    billingCodeIndex: string = '';

    inactiveBy: string = '';
    isDefault: boolean = false;

    // for only font-end
    edit: boolean = false;
    view: boolean = false;
   
    validCost1: boolean = false;
    validCost3: boolean = false;
    validCost5: boolean = false;
    validCost6: boolean = false;
    validSales1: boolean = false;
    validSales3: boolean = false;
    validSales5: boolean = false;
    validSales6: boolean = false;
    
    isOperation: boolean = false;
    isAll: boolean = false;
    billingCodeOthers : NCodeChargeOthers[] = [];
    salesCostList : SalesCostCode[] = [
      //new SalesCostCode({ opTypeLabel: '', opType: 'OI', shipmentType: 'DS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: 'OI', opType: 'OI', shipmentType: 'IDS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'OI', shipmentType: 'TS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'OE', shipmentType: 'DS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: 'OE', opType: 'OE', shipmentType: 'IDS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'OE', shipmentType: 'TS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'AI', shipmentType: 'DS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: 'AI', opType: 'AI', shipmentType: 'IDS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'AI', shipmentType: 'TS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'AE', shipmentType: 'DS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: 'AE', opType: 'AE', shipmentType: 'IDS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'AE', shipmentType: 'TS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'OT', shipmentType: 'DS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: 'OT', opType: 'OT', shipmentType: 'IDS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      //new SalesCostCode({ opTypeLabel: '', opType: 'OT', shipmentType: 'TS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      new SalesCostCode({ opTypeLabel: 'WH', opType: 'WH', shipmentType: 'DS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' }),
      new SalesCostCode({ opTypeLabel: 'OD', opType: 'OD', shipmentType: 'DS', sCode: '', sCodeName: '', cCode: '', cCodeName: '' })

    ];

    constructor(init?:Partial<NCodeCharge>) {
        super();
        this.key='id';
        //Object.assign(this, init);
        this.applyInitDataExcludingNull(this, init);
        this.noTrackProps.push('id','edit','view');
        if(this.id === 0) this.id = this.GetNextId();

        if(this.billingCodeOthers.length > 0) {
            this.billingCodeOthers = this.billingCodeOthers.map(d => new NCodeChargeOthers(d));
        } else {
            this.billingCodeOthers = [];
        }
    }

    getDbMappings(arg?: any): IDictionary<DBMappingInfo> {
        const dicFieldMap: IDictionary<DBMappingInfo> = {};
        _.keys(NCodeCharge.dicFieldMappings).forEach(m => {
            dicFieldMap[m] = NCodeCharge.dicFieldMappings[m];
        });

        _.keys(NCodeChargeOthers.dicFieldMappings).forEach(m => {
            dicFieldMap[`billingCodeOthers.${m}`] = NCodeChargeOthers.dicFieldMappings[m];
        });
        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_NCodeCharge' }),
        'code': new DBMappingInfo({ field: 'F_Code', table: 'T_NCodeCharge' }),
        'codeName': new DBMappingInfo({ field: 'F_CodeName', table: 'T_NCodeCharge' }),
        'description': new DBMappingInfo({ field: 'f_Description', table: 'T_NCodeCharge' }),
        'oi': new DBMappingInfo({ field: 'F_OI', table: 'T_NCodeCharge' }),
        'oo': new DBMappingInfo({ field: 'F_OO', table: 'T_NCodeCharge' }),
        'ai': new DBMappingInfo({ field: 'F_AI', table: 'T_NCodeCharge' }),
        'ao': new DBMappingInfo({ field: 'F_AO', table: 'T_NCodeCharge' }),
        'wh': new DBMappingInfo({ field: 'F_WH', table: 'T_NCodeCharge' }),
        'ot': new DBMappingInfo({ field: 'F_OT', table: 'T_NCodeCharge' }),
        'chgType1': new DBMappingInfo({ field: 'F_ChgType1', table: 'T_NCodeCharge' }),
        'chgType2': new DBMappingInfo({ field: 'F_ChgType2', table: 'T_NCodeCharge' }),
        'chgType3': new DBMappingInfo({ field: 'F_ChgType3', table: 'T_NCodeCharge' }),
        'chgType5': new DBMappingInfo({ field: 'F_ChgType5', table: 'T_NCodeCharge' }),
        'chgType6': new DBMappingInfo({ field: 'F_ChgType6', table: 'T_NCodeCharge' }), //Payroll
        'sales1': new DBMappingInfo({ field: 'F_Sales1', table: 'T_NCodeCharge' }),
        'sales2': new DBMappingInfo({ field: 'F_Sales2', table: 'T_NCodeCharge' }),
        'sales3': new DBMappingInfo({ field: 'F_Sales3', table: 'T_NCodeCharge' }),
        'sales5': new DBMappingInfo({ field: 'F_Sales5', table: 'T_NCodeCharge' }),
        'sales6': new DBMappingInfo({ field: 'F_Sales6', table: 'T_NCodeCharge' }), //Payroll
        'cost1': new DBMappingInfo({ field: 'F_Cost1', table: 'T_NCodeCharge' }),
        'cost2': new DBMappingInfo({ field: 'F_Cost2', table: 'T_NCodeCharge' }),
        'cost3': new DBMappingInfo({ field: 'F_Cost3', table: 'T_NCodeCharge' }),
        'cost5': new DBMappingInfo({ field: 'F_Cost5', table: 'T_NCodeCharge' }),
        'cost6': new DBMappingInfo({ field: 'F_Cost6', table: 'T_NCodeCharge' }), //Payroll
        'inActive': new DBMappingInfo({ field: 'F_inactive', table: 'T_NCodeCharge' }),
        'localDesc': new DBMappingInfo({ field: 'F_LocalDesc', table: 'T_NCodeCharge' }),
        'jobNumber': new DBMappingInfo({ field: 'F_JobNumber', table: 'T_NCodeCharge' }),
        'remark': new DBMappingInfo({ field: 'F_Remark', table: 'T_NCodeCharge' }),
        'isUseInInvoice': new DBMappingInfo({ field: 'F_IsUseInInvoice', table: 'T_NCodeCharge' }),
        'isUseInBill': new DBMappingInfo({ field: 'F_IsUseInBill', table: 'T_NCodeCharge' }),
        'useSuntek': new DBMappingInfo({ field: 'F_UseSuntek', table: 'T_NCodeCharge' }),
        'inactiveDate': new DBMappingInfo({ field: 'F_InactiveDate', table: 'T_NCodeCharge' }),
        'inactiveBy': new DBMappingInfo({ field: 'InactiveBy', table: 'T_NCodeCharge' }),
        'isUseInWithhold': new DBMappingInfo({ field: 'F_IsUseInWithhold', table: 'T_NCodeCharge' }), //Payroll
        'isUseInCorporate': new DBMappingInfo({ field: 'F_IsUseInCorporate', table: 'T_NCodeCharge' }), //Payroll
    };

    setChildTrackable(value: boolean): void {
        if(this.billingCodeOthers.length > 0) {
            this.billingCodeOthers.forEach(c => c.trackable = value);
        }
        if(this.salesCostList.length > 0) {
            this.salesCostList.forEach(c => c.trackable = value);
        }
    }
}
export class NCodeChargeOthers extends TrackableEntity {
    id: number = 0;
    code: string = '';
    codeName: string = '';
    description: string = '';
    localDesc: string = '';
    opType :  string = '';
    sales1: string = '';
    cost1: string = '';
    sales3: string = '';
    cost3: string = ''; 
    sales5: string = '';
    cost5: string = '';
    sales1Name: string = '';
    sales3Name: string = '';
    sales5Name: string = '';
    sales6Name: string = '';
    cost1Name: string = '';
    cost3Name: string = '';
    cost5Name: string = '';
    inActive: boolean = false;

    changedMainprop : boolean = false;
    
    constructor(init?:Partial<NCodeChargeOthers>) {
        super();
        this.key='id';
        if(this.id === 0) this.id = this.GetNextId();
        this.applyInitDataExcludingNull(this, init);
        this.noTrackProps.push('opType','shipmentType');
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return NCodeChargeOthers.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {};
}

export class SalesCostCode extends TrackableEntity {    
    id: number = 0;
    opType :  string = '';
    shipmentType: string = '';
    sCode: string = '';
    sCodeName: string = '';
    cCode: string = '';
    cCodeName: string = '';
    inActive: boolean = false;
    opTypeLabel :  string = '';

    constructor(init?:Partial<SalesCostCode>) {
        super();
        this.key='sCode';
        this.applyInitDataExcludingNull(this, init);
        this.noTrackProps.push('opType','shipmentType');
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return SalesCostCode.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {};
}
